// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { allowEnterInTextarea } from "./patches/allow_enter_in_textarea"
allowEnterInTextarea()
import "flyonui/flyonui"
import "trix"
import "@rails/actiontext"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
import "https://kit.fontawesome.com/82ced3c299.js"

function initHSStaticMethods() {
  window.HSStaticMethods.autoInit()
}

function cleanupFlyonUI() {
  // Close any open tooltips from FlyonUI to prevent them from persisting across Turbo visits
  document.querySelectorAll(".tooltip").forEach((el) => {
    window.HSTooltip.getInstance(el, true).element.hide()
  })
}

document.addEventListener("turbo:load", initHSStaticMethods)
document.addEventListener("turbo:render", initHSStaticMethods)
document.addEventListener("turbo:frame-load", initHSStaticMethods)
document.addEventListener("turbo:before-render", cleanupFlyonUI)
document.addEventListener("turbo:after-stream-render", initHSStaticMethods)

const afterRenderEvent = new Event("turbo:after-stream-render")
addEventListener("turbo:before-stream-render", (event) => {
  const originalRender = event.detail.render

  event.detail.render = function (streamElement) {
    originalRender(streamElement)
    document.dispatchEvent(afterRenderEvent)
  }
})

// Redirect on turbo:frame-missing
document.addEventListener("turbo:frame-missing", (event) => {
  const {
    detail: { response, visit }
  } = event
  event.preventDefault()
  visit(response.url)
})

// Close any open <details> elements when the Escape key is pressed
document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    document.querySelectorAll("details[open]").forEach((element) => {
      element.removeAttribute("open")
    })
  }
})
